import { render } from "./AdvancedDashboard.vue?vue&type=template&id=648dd5bb&scoped=true"
import script from "./AdvancedDashboard.vue?vue&type=script&lang=js"
export * from "./AdvancedDashboard.vue?vue&type=script&lang=js"

import "./AdvancedDashboard.vue?vue&type=style&index=0&id=648dd5bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648dd5bb"]])

export default __exports__